module.exports = __webpack_public_path__ + "img/nav-header-mobile-eternity@2x.3386216.webp";